import React from 'react';

const PriorityGradingList = () => {
  return <h2>PriorityGradingList</h2>;
};

export default PriorityGradingList;
